namespace SolovisGateway.Admin.DbServers {

    /**
     * AllDbInfoListControl presents a list of all databases on all of the registered database servers.
     */
    export class AllDbInfoListControl extends Solovis.UI.BaseControl {

        private _dbInfoList;
        private _errors;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        private _targetWidth: number;
        private _targetHeight: number;

        constructor(options) {
            super(options);

            this._targetWidth = options.width ? options.width : 500;
            this._targetHeight = options.height ? options.height : 500;
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetAllDatabaseInfo",
                { includeSizeInMB: true },
                function (response, success) {                    
                    if (success) {
                        self._dbInfoList = response.result.databases;
                        self._errors = response.result.errors;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            let self = this;

            this.container.css("overflow", "hidden");

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._dbInfoList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },
                filterRow: {
                    visible: true
                },
                export: {
                    enabled: true
                },
                groupPanel: {
                    visible: true
                },
                scrolling: {
                    mode: "virtual"
                },

                width: this._targetWidth,
                height: this._targetHeight,

                columns: [
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let dbData = options.data;
                            self._buildActionsCell(container, dbData);
                        },
                        width: 75
                    },
                    {
                        dataField: 'name',
                        dataType: 'string',
                        caption: 'Database Name',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'server',
                        dataType: 'string',
                        caption: 'Server',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        name: 'sizeInMB',
                        dataField: 'sizeInMB',
                        dataType: 'number',
                        caption: 'Size (MB)',
                        allowSorting: true,
                        width: 150
                    },
                    {
                        dataField: 'azureEdition',
                        dataType: 'string',
                        caption: 'Azure Edition',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'azureServiceObjective',
                        dataType: 'string',
                        caption: 'Azure Service Objective',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'azureElasticPoolName',
                        dataType: 'string',
                        caption: 'Elastic Pool Name',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'dataEnvironmentSubdomain',
                        dataType: 'string',
                        caption: 'Data Environment',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'organizationName',
                        dataType: 'string',
                        caption: 'Organization',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'dataEnvironmentId',
                        dataType: 'number',
                        caption: 'Data Environment Id',
                        allowSorting: true,
                        width: 150,
                        visible: false
                    },
                    {
                        dataField: 'organizationId',
                        dataType: 'number',
                        caption: 'Organization Id',
                        allowSorting: true,
                        width: 150,
                        visible: false
                    },
                    {
                        dataField: 'organizationCode',
                        dataType: 'string',
                        caption: 'Organization Code',
                        allowSorting: true,
                        width: 200,
                        visible: false
                    }                              
                ],

                summary: {
                    totalItems: [
                        {
                            column: 'sizeInMB',
                            summaryType: 'sum'
                        }
                    ],

                    groupItems: [
                        {
                            column: 'sizeInMB',
                            summaryType: 'sum'
                        }                        
                    ]
                }
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");            
        }


        private _buildActionsCell(container, dbData) {
            let self = this;
            let columnDiv = container;

            if (dbData.isSqlAzure) {
                let changeServiceTierLink = $("<a>").appendTo(columnDiv);
                $("<span class='fa fa-pencil'>").appendTo(changeServiceTierLink);
                changeServiceTierLink.attr("title", "Change Service Tier");
                changeServiceTierLink.click(function () {
                    let changeServiceTierDialog = new ChangeDatabaseServiceTierDialog({
                        server: dbData.server,
                        databaseName: dbData.name,
                        initialElasticPool: dbData.azureElasticPoolName,
                        initialServiceTier: !dbData.azureElasticPoolName ? dbData.azureServiceObjective : null
                    });
                    changeServiceTierDialog.show();
                });
            }
        }


        public setWidth(newWidth: number) {
            this._targetWidth = newWidth;

            if (this.container) {
                this.container.outerWidth(newWidth);
            }

            if (this._dataGrid) {
                this._dataGrid.option("width", newWidth);
            }
        }

        public setHeight(newHeight: number) {
            this._targetHeight = newHeight;

            if (this.container) {
                this.container.outerHeight(newHeight);
            }

            if (this._dataGrid) {
                this._dataGrid.option("height", newHeight);
            }
        }
    }

}